module.exports = __webpack_public_path__ + "6deb3d8163f82f5edb28faf7ef4189ee.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/power_of_authenticity_graph_mobile.png
// module id = 567
// module chunks = 0